import { IModelAdapter } from '../../model/adapters/model-adapter';
import { OwnedSet } from '../../model/base/ownedset';
import { Tag } from '../../model/tags/tags';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function tagsToAnnotations(annotations: any, tags: OwnedSet<Tag>, tagAdapter: IModelAdapter<any, any>): void {
    if (!tags) {
        return;
    }
    for (const tagNamed of tags) {
        const tagResource = tagAdapter.toResource(tagNamed);
        if (tagResource) {
            annotations.push(tagResource);
        }
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function annotationsToTags(tags: OwnedSet<Tag>, malformedTags: OwnedSet<Tag>, annotations: any, tagAdapter: IModelAdapter<any, any>): void {
    if (!annotations) {
        return;
    }
    for (const tagNamed of annotations) {
        if (typeof tagNamed === 'string') {
            tags.add(tagAdapter.toModel(tagNamed));
        } else {
            malformedTags.add(tagAdapter.toModel(tagNamed));
        }
    }
}
